import React from 'react';
import styles from './index.module.scss';
import ContentLoader from 'react-content-loader';

function BrandLoaderCard({ category }) {
  return (
    <div className={styles.main}>
      {category?.map((category, index) => {
        return (
          <div key={index} className={styles.brandCard}>
            <div className={styles.categoryName}>
              <span>{category}</span>
              <div className={styles.underline}></div>
            </div>
            <div className={styles.brandList}>
              {[...Array(4)].map((_, index) => (
                <div key={index} className={styles.brandItem}>
                  <ContentLoader
                    speed={2}
                    backgroundColor="#1C2B5A"
                    foregroundColor="#162143"
                    width={64}
                    height={64}
                    style={{
                      marginBottom: '8px',
                    }}
                  >
                    <rect x="0" y="0" width="64" height="64" rx="8" ry="8" />
                  </ContentLoader>
                  <ContentLoader
                    speed={2}
                    backgroundColor="#1C2B5A"
                    foregroundColor="#162143"
                    width={80}
                    height={12}
                    style={{
                      marginBottom: '8px',
                      height: '14px',
                    }}
                  >
                    <rect x="0" y="0" width="80" height="30" rx="2" ry="2" />
                  </ContentLoader>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default BrandLoaderCard;
